import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'

import LabeledText from 'components/atoms/labeled-text'
import Typography from 'components/molecules/typography'

const SellingPriceContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
`

const StyledSellingPrice = styled(LabeledText)`
  padding-right: ${({ theme }) => theme.sizeByFactor(1)};
`

const StyledTypography = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.sizeByFactor(0.25)};
`

const CarfileSellingPrice = ({
  carfile,
  sellingprice,
  taxMargin,
  carDetailsSummary,
  highlight,
  type,
  removeMargin,
}) => {
  const { t } = useTranslation()
  const includingVAT = carfile.verkoopprijs_incbtw
  const showTax = taxMargin !== 'marge'
  const sellingPriceBtw = includingVAT ? t('inclBtw') : t('exclBtw')

  return (
    <SellingPriceContainer>
      <StyledSellingPrice
        title={carDetailsSummary ? '' : t('sellingPrice')}
        value={sellingprice || t('unknown')}
        price={!!sellingprice}
        highlight={highlight}
        data-test-e2e="selling-price"
        type={type}
        removeMargin={removeMargin}
      />
      {!carDetailsSummary && sellingprice && showTax && (
        <StyledTypography type="InlineBodyTextBold">
          {sellingPriceBtw}
        </StyledTypography>
      )}
    </SellingPriceContainer>
  )
}

CarfileSellingPrice.propTypes = {
  carfile: PropTypes.object.isRequired,
  sellingprice: PropTypes.string,
  taxMargin: PropTypes.string.isRequired,
  carDetailsSummary: PropTypes.bool,
  highlight: PropTypes.bool,
  type: PropTypes.string,
  removeMargin: PropTypes.bool,
}

CarfileSellingPrice.defaultProps = {
  sellingprice: null,
  carDetailsSummary: false,
  highlight: true,
}

export default CarfileSellingPrice
